import CustomersCreate from './CustomersCreate';

export default CustomersCreate;
